module.exports = __webpack_public_path__ + "static/laser-2443eae417c85d59ddd1f95e4f544151.mp3";